<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :batch-actions="batchActions"
    :form="form"
    :title="$t('model.trade')"
    resource="trades"
  >
    <template slot="action">
      <bean-import-button
        can='trades.create'
        buttonText="导入"
        tooltipText="下载导入模板"
        url="/trades/import"
        loadingToast="导入中...请不要刷新页面"
        excelTemplateDownloadLink="/admin_api/v1/trades/import_template"
      />
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/trades.js';
import _ from 'lodash';

const AMOUNT_HINT = {
  'AllotTrade': '请输入大于 0 的金额',
  'RedeemTrade': '请输入小于 0 的金额',
  'AchievementPayTrade': '请输入小于 0 的金额',
  'CashDividendTrade': '请输入小于 0 的金额',
  'DividendReinvestmentTrade': '请输入 0',
}

const SHARE_HINT = {
  'AllotTrade': '请输入大于 0 的份额',
  'RedeemTrade': '请输入小于 0 的份额',
  'AchievementPayTrade': '请输入小于 0 的份额',
  'CashDividendTrade': '请输入 0',
  'DividendReinvestmentTrade': '请输入大于 0 的份额',
}

@Component
export default class Trades extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [

    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'account',
      'fund',
      'type',
      'state',
      {
        key: 'amount',
        sortable: true,
        renderCell: 'money',
        width: 120,
      },
      {
        key: 'share',
        sortable: true,
        renderCell: 'money',
        width: 120,
      },
      {
        key: 'value',
        sortable: true,
        renderCell: 'netValue',
      },
      {
        key: 'confirm_date',
        sortable: true,
      },
      { key: 'confirm_file', width: 200 },
      type === 'show' && 'parent',
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'type',
      {
        key: 'amount',
        renderCell: {
          hint: AMOUNT_HINT[data.type],
        },
      },
      {
        key: 'share',
        renderCell: {
          hint: SHARE_HINT[data.type],
        },
      },
      'value',
      'account_id',
      'fund_id',
      'confirm_date',
      {
        key: 'confirm_file',
        renderCell: {
          props: {
            accept: 'application/pdf',
            type: 'application',
            size: 20
          }
        }
      },
      'parent_id',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      row.state === 'pending' && {
        component: 'confirmButton',
        props: {
          label: '确认',
          type: 'primary',
          can: 'trades.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/trades/${row.id}/confirm`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'trades.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'trades.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
          await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>
    ];
  }
}

export const route = [
  {
    path: '/trades',
    name: 'trades.index',
    component: Trades,
    props: {
      type: 'index',
    }
  },
  {
    path: '/trades/new',
    name: 'trades.new',
    component: Trades,
    props: {
      type: 'new',
    }
  },
  {
    path: '/trades/:id',
    name: 'trades.show',
    component: Trades,
    props: {
      type: 'show',
    }
  },
  {
    path: '/trades/:id/edit',
    name: 'trades.edit',
    component: Trades,
    props: {
      type: 'edit'
    }
  }
]
</script>
